import { render, staticRenderFns } from "./QuestionarioSocioLista.vue?vue&type=template&id=3ec2d445&scoped=true&"
import script from "./QuestionarioSocioLista.vue?vue&type=script&lang=js&"
export * from "./QuestionarioSocioLista.vue?vue&type=script&lang=js&"
import style0 from "./QuestionarioSocioLista.vue?vue&type=style&index=0&id=3ec2d445&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec2d445",
  null
  
)

export default component.exports